// extracted by mini-css-extract-plugin
module.exports = {"container":"pc_container__x1xxk","content":"pc_content__CO4Rg","accessories":"pc_accessories__vNAwT"};